import { _fetch as fetchSecure } from '@hobs/utils/fetch';
import {
  UNITS,
  UNIT,
  ADD,
  UPDATE,
  REMOVE,
  UNITSTATICDATA,
  PHASECHANGE,
  FINANCE,
  UPDATEFINANCEDATA,
  WHOCANCONFIRMSOR,
  CLEARFINANCEDATA,
  CANCREATESERVICEREQUEST,
  SUMMARY,
  CONFIRM_ISOR,
  GETSORPARTY,
  CLEAR_SOR_PARTY,
  CONFIRM_FSOR,
  VALIDATE_CONFIRM_FSOR
} from '@hobs/constants/sor';
import { actionCreator } from '@hobs/actions/utils/utils';

export function getSorUnits(filter = 'All') {
  return dispatch => {
    dispatch(request());

    return fetchSecure(
      `StatementOfRequirements/SendingNationUnitInformation/Units/${filter}`
    )
      .then(response => {
        if (response) {
          dispatch(success(response.payload));

          return { success: true };
        } else {
          dispatch(failure(response.toString()));

          return { success: false, ...response };
        }
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };

  function request() {
    return { type: UNITS.REQUEST };
  }
  function success(response) {
    return { type: UNITS.SUCCESS, payload: response };
  }
  function failure(error) {
    return { type: UNITS.FAILURE, error };
  }
}

export function getSorFinanceData() {
  return dispatch => {
    dispatch(request());

    return fetchSecure('StatementOfRequirements/SendingNationInfo')
      .then(response => {
        if (response && response.status === 200) {
          dispatch(success(response.payload));
          return { success: true, data: response.payload };
        } else {
          dispatch(failure(response.toString()));
          return { success: false, ...response };
        }
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };

  function request() {
    return { type: FINANCE.REQUEST };
  }
  function success(response) {
    return { type: FINANCE.SUCCESS, payload: response };
  }
  function failure(error) {
    return { type: FINANCE.FAILURE, error };
  }
}

export function clearSorFinanceData() {
  return dispatch => {
    dispatch({ type: CLEARFINANCEDATA.SUCCESS });
  };
}

export function getSorFinanceDataForSubmit() {
  return dispatch => {
    dispatch(request());

    return fetchSecure('StatementOfRequirements/SendingNationInfo/ForSubmit')
      .then(response => {
        if (response && response.status === 200) {
          dispatch(success(response.payload));
          return { success: true, ...response.payload };
        } else {
          dispatch(failure(response.toString()));
          return { success: false, ...response };
        }
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };

  function request() {
    return { type: WHOCANCONFIRMSOR.REQUEST };
  }
  function success(response) {
    return { type: WHOCANCONFIRMSOR.SUCCESS, payload: response };
  }
  function failure(error) {
    return { type: WHOCANCONFIRMSOR.FAILURE, error };
  }
}

export function updateSorFinanceData(sorFinanceData) {
  return dispatch => {
    dispatch(request());

    return fetchSecure('StatementOfRequirements/SaveSendingNationInfo', {
      body: sorFinanceData,
      method: 'POST'
    })
      .then(response => {
        if (response && response.status === 200) {
          dispatch(success());
          return { success: true };
        } else {
          dispatch(failure(response.toString()));
          return { success: false, ...response };
        }
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };

  function request() {
    return { type: UPDATEFINANCEDATA.REQUEST };
  }
  function success() {
    return { type: UPDATEFINANCEDATA.SUCCESS };
  }
  function failure(error) {
    return { type: UPDATEFINANCEDATA.FAILURE, error };
  }
}

export function getSorUnit(unitId) {
  return dispatch => {
    dispatch(request());
    return fetchSecure(
      `StatementOfRequirements/SendingNationUnitInformation/${unitId}`
    )
      .then(response => {
        if (response && response.status === 200) {
          dispatch(success(response.payload));

          return { success: true };
        } else {
          dispatch(failure(response.toString()));

          return { success: false, ...response };
        }
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };

  function request() {
    return { type: UNIT.REQUEST };
  }
  function success(response) {
    return { type: UNIT.SUCCESS, payload: response };
  }
  function failure(error) {
    return { type: UNIT.FAILURE, error };
  }
}

export function resetSorUnit() {
  return {
    type: UNIT.RESET
  };
}

export function addElementToExercise(unitId) {
  return dispatch => {
    dispatch(request());
    return fetchSecure('StatementOfRequirements/SendingNationUnitInformation', {
      body: { unitId },
      method: 'POST'
    })
      .then(response => {
        if (response && response.status === 200) {
          dispatch(success(response.payload));

          return { success: true };
        } else {
          dispatch(failure(response.toString()));

          return { success: false, ...response };
        }
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };

  function request() {
    return { type: ADD.REQUEST };
  }
  function success(response) {
    return { type: ADD.SUCCESS, payload: response };
  }
  function failure(error) {
    return { type: ADD.FAILURE, error };
  }
}

export function updateUnit(body) {
  return dispatch => {
    dispatch(request());
    return fetchSecure('StatementOfRequirements/SendingNationUnitInformation', {
      body: body,
      method: 'PUT'
    })
      .then(response => {
        if (response && response.status === 200) {
          dispatch(success(response.payload));

          return { success: true };
        } else {
          dispatch(failure(response.toString()));

          return { success: false, ...response };
        }
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };
  function request() {
    return { type: UPDATE.REQUEST };
  }
  function success(response) {
    return { type: UPDATE.SUCCESS, payload: response };
  }
  function failure(error) {
    return { type: UPDATE.FAILURE, error };
  }
}

export function getUnitStaticData(unitId) {
  return dispatch => {
    dispatch(request());
    return fetchSecure(
      `StatementOfRequirements/SendingNationUnitInformation/${unitId}/ForSubmit`
    )
      .then(response => {
        if (response && response.status === 200) {
          dispatch(success(response.payload));

          return { success: true };
        } else {
          dispatch(failure(response.toString()));

          return { success: false, ...response };
        }
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };
  function request() {
    return { type: UNITSTATICDATA.REQUEST };
  }
  function success(response) {
    return { type: UNITSTATICDATA.SUCCESS, payload: response };
  }
  function failure(error) {
    return { type: UNITSTATICDATA.FAILURE, error };
  }
}

export function removeUnit(unitId) {
  return dispatch => {
    dispatch(request());
    return fetchSecure('StatementOfRequirements/SendingNationUnitInformation', {
      body: { unitId },
      method: 'DELETE'
    })
      .then(response => {
        if (response && response.status === 200) {
          dispatch(success(response.payload));

          return { success: true };
        } else {
          dispatch(failure(response.toString()));

          return { success: false, ...response };
        }
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };
  function request() {
    return { type: REMOVE.REQUEST };
  }
  function success(response) {
    return { type: REMOVE.SUCCESS, payload: response };
  }
  function failure(error) {
    return { type: REMOVE.FAILURE, error };
  }
}

export function changePhase(phaseName) {
  return dispatch => {
    dispatch(request());
    return fetchSecure(`StatementOfRequirements/ChangePhase/${phaseName}`, {
      method: 'POST'
    })
      .then(response => {
        if (response && response.status === 200) {
          dispatch(success(response.payload));
          return { success: true };
        } else {
          dispatch(failure(response.toString()));
          return { success: false, ...response };
        }
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };

  function request() {
    return { type: PHASECHANGE.REQUEST };
  }
  function success(response) {
    return { type: PHASECHANGE.SUCCESS, payload: response };
  }
  function failure(error) {
    return { type: PHASECHANGE.FAILURE, error };
  }
}
export function getCanCreateServiceRequest() {
  return dispatch => {
    dispatch(request());

    return fetchSecure('StatementOfRequirements/CanCreateServiceRequest')
      .then(response => {
        if (response && response.status === 200) {
          dispatch(success(response.payload));
          return { success: true, data: response.payload };
        } else {
          dispatch(failure(response.toString()));
          return { success: false, ...response };
        }
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };

  function request() {
    return { type: CANCREATESERVICEREQUEST.REQUEST };
  }
  function success(response) {
    return { type: CANCREATESERVICEREQUEST.SUCCESS, payload: response };
  }
  function failure(error) {
    return { type: CANCREATESERVICEREQUEST.FAILURE, error };
  }
}

export function getSorSummary() {
  return dispatch => {
    dispatch(request());

    return fetchSecure('StatementOfRequirements/Summary')
      .then(response => {
        if (response && response.status === 200) {
          dispatch(success(response.payload));
          return { success: true, data: response.payload };
        } else {
          dispatch(failure(response.toString()));
          return { success: false, ...response };
        }
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };
  function request() {
    return { type: SUMMARY.REQUEST };
  }
  function success(response) {
    return { type: SUMMARY.SUCCESS, payload: response };
  }
  function failure(error) {
    return { type: SUMMARY.FAILURE, error };
  }
}

export function confirmSor() {
  return dispatch => {
    dispatch(request());

    return fetchSecure('StatementOfRequirements/ConfirmIsor', {
      method: 'POST'
    })
      .then(response => {
        if (response && response.status === 200) {
          dispatch(success());
          return { success: true, payload: response.payload };
        } else {
          dispatch(failure(response.toString()));
          return { success: false, ...response };
        }
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };

  function request() {
    return { type: CONFIRM_ISOR.REQUEST };
  }
  function success() {
    return { type: CONFIRM_ISOR.SUCCESS };
  }
  function failure(error) {
    return { type: CONFIRM_ISOR.FAILURE, error };
  }
}

export function getSorParty() {
  return dispatch => {
    dispatch(request());

    return fetchSecure('StatementOfRequirements/Summary')
      .then(response => {
        if (response && response.status === 200) {
          dispatch(success(response.payload));
          return { success: true, data: response.payload };
        } else {
          dispatch(failure(response.toString()));
          return { success: false, ...response };
        }
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };

  function request() {
    return { type: GETSORPARTY.REQUEST };
  }
  function success(response) {
    return { type: GETSORPARTY.SUCCESS, payload: response };
  }
  function failure(error) {
    return { type: GETSORPARTY.FAILURE, error };
  }
}

export function crealSorParty() {
  return dispatch => {
    dispatch({ type: CLEAR_SOR_PARTY.SUCCESS });
  };
}

export const confirmFsor = () =>
  actionCreator('StatementOfRequirements/ConfirmFsor', CONFIRM_FSOR, {
    method: 'POST'
  });

export const validateConfirmFsor = () =>
  actionCreator(
    'StatementOfRequirements/ValidateConfirmFsor',
    VALIDATE_CONFIRM_FSOR,
    {
      method: 'POST'
    }
  );
